export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer id="contact" className="bg-[#1a1a2e] text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand col */}
          <div className="lg:col-span-1">
            <img
              src="https://cdn11.bigcommerce.com/s-xkucyvxj20/images/stencil/original/onestopclearanceshop_350_x_50_1669484556__30640.original.png"
              alt="OneStopClearanceShop"
              className="h-8 w-auto object-contain mb-4 brightness-0 invert"
            />
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-red-400 mt-0.5 flex-shrink-0"></i>
                <address className="not-italic leading-relaxed">
                  1040 Parkway Industrial Park Drive<br />
                  Buford, GA 30518
                </address>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-red-400 flex-shrink-0"></i>
                <a href="tel:678-936-5391" className="hover:text-white transition-colors cursor-pointer">
                  Call us at 678-936-5391
                </a>
              </li>
            </ul>
            <div className="flex gap-3 mt-5">
              <a
                href="https://www.facebook.com/OneStopClearanceShop/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-red-600 transition-colors cursor-pointer"
                title="Facebook"
              >
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a
                href="https://www.instagram.com/onestopclearanceshop/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-red-600 transition-colors cursor-pointer"
                title="Instagram"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Navigate */}
          <div>
            <h5 className="font-semibold text-white text-sm mb-4 uppercase tracking-wider">Navigate</h5>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="https://onestopclearanceshop.com/sitemap.php" rel="nofollow" className="hover:text-white transition-colors cursor-pointer">Sitemap</a></li>
              <li><a href="#inventory" className="hover:text-white transition-colors cursor-pointer">Inventory</a></li>
              <li><a href="#about" className="hover:text-white transition-colors cursor-pointer">About</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h5 className="font-semibold text-white text-sm mb-4 uppercase tracking-wider">Categories</h5>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#inventory" className="hover:text-white transition-colors cursor-pointer">Fiberglass Batts</a></li>
              <li><a href="#inventory" className="hover:text-white transition-colors cursor-pointer">Fiberglass Rolls</a></li>
<li><a href="#inventory" className="hover:text-white transition-colors cursor-pointer">House Wrap</a></li>
              <li>
                <a href="https://onestopclearanceshop.com/brands/" rel="nofollow" className="hover:text-white transition-colors cursor-pointer">
                  View All
                </a>
              </li>
            </ul>
          </div>

          {/* Popular Brands */}
          <div>
            <h5 className="font-semibold text-white text-sm mb-4 uppercase tracking-wider">Popular Brands</h5>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="https://onestopclearanceshop.com/brands/" rel="nofollow" className="hover:text-white transition-colors cursor-pointer">View All</a></li>
            </ul>

            <div className="mt-6">
              <h5 className="font-semibold text-white text-sm mb-3 uppercase tracking-wider">Hours</h5>
              <p className="text-gray-400 text-sm leading-relaxed">
                Pickup by appointment only.<br />
                Call or text to schedule.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs">
            &copy; {year} OneStopClearanceShop. All rights reserved.
          </p>
          <div className="flex items-center gap-2 flex-wrap justify-center">
            {["Visa", "Mastercard", "Amex", "Discover", "PayPal", "Apple Pay", "Google Pay"].map((method) => (
              <span
                key={method}
                className="bg-white/10 text-gray-400 text-xs px-2 py-0.5 rounded"
              >
                {method}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
